import '../App.css';
import NavBar from "./ui/NavBar"

function Header() {
return (
    <header className='header'>
        <NavBar/>
    </header>
)
}

export default Header;